module.exports = __webpack_public_path__ + "media/images/career_camp/2023/mountains_1-4d32939daa5b09c73187fad6b936d393.png";